class StringUtil {

    static padStart(input: string, charToPad: string, minLength: number): string {
        let paddedStr = '';
        if(input.length < minLength){
            for(let i = 0; i < minLength - input.length; i++){
                paddedStr += charToPad;
            }
        }
        paddedStr += input;
        return paddedStr;
    }

    static reverse(input: string): string {
        var o = '';
        for (var i = input.length - 1; i >= 0; i--)
            o += input[i];
        return o;
    }

    static truncateWithEllipsis(input: string, maxLength: number): string {
        const ellipsis = "...";
        if(input.length > maxLength){
            return input.substr(0, maxLength-1-ellipsis.length) + "...";
        } else {
          return input;
        }
    }

    static pluralize(singular:string, count: number): string {
        return count == 1 ? singular : `${singular}s`;
    }



}

export {StringUtil}